export const formatDate = (isoString: string): string => {
  const date = new Date(isoString);
  const months = [
    "Jan.", "Feb.", "Mar.", "Apr.", "May.", "Jun.",
    "Jul.", "Aug.", "Sep.", "Oct.", "Nov.", "Dec."
  ];
  return `${months[date.getUTCMonth()]} ${String(date.getUTCDate()).padStart(2, "0")}, ${date.getUTCFullYear()}`;
};

export const formatTime = (isoString: string): string => {
  const date = new Date(isoString);
  const hours = date.getUTCHours() % 12 || 12;      // UTC hours
  const minutes = String(date.getUTCMinutes()).padStart(2, "0");  // UTC minutes
  const ampm = date.getUTCHours() >= 12 ? "PM" : "AM";
  return `${hours}:${minutes} ${ampm}`;
};

export const formatScheduleForReport = (from: string, to: string) => {
  // Replace space with "T" to ensure Date parses correctly
  const start = new Date(from.replace(" ", "T"));
  const end = new Date(to.replace(" ", "T"));

  const month = start.toLocaleString("en-US", { month: "short" });
  const year = start.getFullYear();

  const formatTime = (date: Date) => {
    const hours = date.getHours() % 12 || 12;            // 12-hour format
    const minutes = String(date.getMinutes()).padStart(2, "0");  // pad minutes
    const ampm = date.getHours() >= 12 ? "PM" : "AM";
    return `${hours}:${minutes}${ampm}`;               // Colon ensures proper format
  };

  const startTime = formatTime(start);
  const endTime = formatTime(end);

  const dayPart = start.getDate() === end.getDate() ? `${start.getDate()}` : `${start.getDate()}-${end.getDate()}`;

  return `${month}. ${dayPart}, ${year} ${startTime}-${endTime}`;
};

export const formatScheduleForClientReport = (from: string, to: string) => {
  const start = new Date(from.replace(" ", "T"));
  const end = new Date(to.replace(" ", "T"));

  const month = start.toLocaleString("en-US", { month: "short" });
  const year = start.getFullYear();

  const formatTime = (date: Date) => {
    const hours = date.getHours() % 12 || 12;            // 12-hour format
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const ampm = date.getHours() >= 12 ? "PM" : "AM";
    return `${hours}:${minutes}${ampm}`;               // keep colon
  };

  const startTime = formatTime(start);
  const endTime = formatTime(end);

  const dayPart =
    start.getDate() === end.getDate()
      ? `${start.getDate()}`
      : `${start.getDate()}-${end.getDate()}`;

  return `${month}. ${dayPart}, ${year} ${startTime}-${endTime}`;
};

export const formatDateFromApi = (iso: string) => {
  if (!iso) return '';
  return new Date(iso).toISOString().split('T')[0];
};

export const formatTimeFromApi = (iso: string) => {
  if (!iso) return '';
  return new Date(iso).toISOString().split('T')[1].slice(0, 5);
};

export const parseBackendLocalDate = (dateString?: string | null): number | null => {
  if (!dateString) return null;

  // Remove timezone designator so JS treats it as local time.
  return new Date(dateString.replace(/Z$/, "")).getTime();
};